module.exports = __webpack_public_path__ + "img/TyunzhenshiA.fb4342a7.svg";